import { TranslationMessages } from 'react-admin';
import chineseMessages from 'ra-language-chinese';
import { outboundQueryList } from '../Page/outboundQuery/outboundQueryList';

const customChineseMessages: TranslationMessages = {
    ...chineseMessages,
    resources: {
        customers: {
            name: '客户',
            fields: {
                orders: '订单',
                first_seen: '首次访问时间',
                full_name: '姓名',
                groups: '客户细分',
                last_seen: '最后访问时间',
                last_seen_gte: '自...以来访问过',
                name: '姓名',
                total_spent: '总消费金额',
                password: '密码',
                confirm_password: '确认密码',
                stateAbbr: '州',
            },
            filters: {
                last_visited: '最后访问时间',
                today: '今天',
                this_week: '本周',
                last_week: '上周',
                this_month: '本月',
                last_month: '上月',
                earlier: '更早',
                has_ordered: '有订单',
                has_newsletter: '订阅了新闻资讯',
                group: '客户细分',
            },
            fieldGroups: {
                identity: '身份信息',
                address: '地址信息',
                stats: '统计信息',
                history: '历史记录',
                password: '密码',
                change_password: '更改密码',
            },
            page: {
                delete: '删除客户',
            },
            errors: {
                password_mismatch:
                    '确认密码与输入的密码不一致。',
            },
            notifications: {
                created:
                    '客户已创建 |||| 已创建 %{smart_count} 个客户',
                updated:
                    '客户已更新 |||| 已更新 %{smart_count} 个客户',
                deleted:
                    '客户已删除 |||| 已删除 %{smart_count} 个客户',
            },
        },
        orders: {
            name: '订单',
            amount: '1 个订单 |||| %{smart_count} 个订单',
            title: '订单 %{reference}',
            fields: {
                basket: {
                    delivery: '运费',
                    reference: '参考编号',
                    quantity: '数量',
                    sum: '小计',
                    tax_rate: '税率',
                    taxes: '税费',
                    total: '总计',
                    unit_price: '单价',
                },
                address: '地址',
                customer_id: '客户',
                date_gte: '订单日期自...',
                date_lte: '订单日期至...',
                nb_items: '商品数量',
                total_gte: '最低金额',
                status: '订单状态',
                returned: '已退货',
            },
            section: {
                order: '订单信息',
                customer: '客户信息',
                shipping_address: '收货地址',
                items: '商品明细',
                total: '总计',
            },
            notifications: {
                created: '订单已创建 |||| 已创建 %{smart_count} 个订单',
                updated: '订单已更新 |||| 已更新 %{smart_count} 个订单',
                deleted: '订单已删除 |||| 已删除 %{smart_count} 个订单',
            },
        },
        invoices: {
            name: '发票',
            fields: {
                date: '发票日期',
                customer_id: '客户',
                order_id: '订单',
                date_gte: '发票日期自...',
                date_lte: '发票日期至...',
                total_gte: '最低金额',
                address: '地址',
            },
            notifications: {
                created: '发票已创建 |||| 已创建 %{smart_count} 张发票',
                updated: '发票已更新 |||| 已更新 %{smart_count} 张发票',
                deleted: '发票已删除 |||| 已删除 %{smart_count} 张发票',
            },
        },
        products: {
            name: '海报',
            fields: {
                category_id: '类别',
                height_gte: '最小高度',
                height_lte: '最大高度',
                height: '高度',
                image: '图片',
                price: '价格',
                reference: '参考编号',
                sales: '销量',
                stock_lte: '低库存',
                stock: '库存',
                thumbnail: '缩略图',
                width_gte: '最小宽度',
                width_lte: '最大宽度',
                width: '宽度',
            },
            tabs: {
                image: '图片',
                details: '详情',
                description: '描述',
                reviews: '评论',
            },
            filters: {
                categories: '类别',
                stock: '库存',
                no_stock: '无库存',
                low_stock: '1 - 9 件',
                average_stock: '10 - 49 件',
                enough_stock: '50 件及以上',
                sales: '销量',
                best_sellers: '畅销商品',
                average_sellers: '一般商品',
                low_sellers: '滞销商品',
                never_sold: '从未售出',
            },
            notifications: {
                created: '海报已创建 |||| 已创建 %{smart_count} 张海报',
                updated: '海报已更新 |||| 已更新 %{smart_count} 张海报',
                deleted: '海报已删除 |||| 已删除 %{smart_count} 张海报',
            },
        },
        categories: {
            name: '类别',
            fields: {
                products: '商品',
            },
            notifications: {
                created:
                    '类别已创建 |||| 已创建 %{smart_count} 个类别',
                updated:
                    '类别已更新 |||| 已更新 %{smart_count} 个类别',
                deleted:
                    '类别已删除 |||| 已删除 %{smart_count} 个类别',
            },
        },
        reviews: {
            name: '评论',
            amount: '1 条评论 |||| %{smart_count} 条评论',
            relative_to_poster: '海报评论',
            detail: '评论详情',
            fields: {
                customer_id: '客户',
                order_id: '订单',
                product_id: '商品',
                date_gte: '评论日期自...',
                date_lte: '评论日期至...',
                date: '评论日期',
                comment: '评论内容',
                rating: '评分',
            },
            action: {
                accept: '批准',
                reject: '拒绝',
            },
            notifications: {
                created: '评论已创建 |||| 已创建 %{smart_count} 条评论',
                updated: '评论已更新 |||| 已更新 %{smart_count} 条评论',
                deleted: '评论已删除 |||| 已删除 %{smart_count} 条评论',
                approved_success: '评论已批准',
                approved_error: '错误：评论未批准',
                rejected_success: '评论已拒绝',
                rejected_error: '错误：评论未拒绝',
            },
        },
        segments: {
            name: '客户细分',
            fields: {
                customers: '客户',
                name: '名称',
            },
            data: {
                compulsive: '冲动型客户',
                collector: '收藏型客户',
                ordered_once: '单次购买客户',
                regular: '常客',
                returns: '退货客户',
                reviewer: '评论者',
            },
        },
    },

    ra: {
        action: {
            add_filter: '增加检索',
            add: '增加',
            back: '回退',
            bulk_actions: '选中%{smart_count}项',
            cancel: '取消',
            clear_input_value: '清空输入',
            clone: '克隆',
            close: '关闭',
            close_menu: '关闭菜单',
            confirm: '确认',
            create: '新建',
            delete: '删除',
            edit: '编辑',
            expand: '展开',
            export: '导出',
            list: '列表',
            open_menu: '打开菜单',
            refresh: '刷新',
            remove: '删除',
            remove_filter: '移除检索',
            save: '保存',
            search: '检索',
            show: '查看',
            sort: '排序',
            undo: '撤销',
            unselect: '反选',
            select_columns: '列选择'
        },
        boolean: {
            true: '是',
            false: '否',
            null: ' ',
        },
        page: {
            create: '新建 %{name}',
            dashboard: '概览',
            edit: '%{name} #%{id}',
            empty: '无 %{name} ',
            error: '出现错误',
            invite: '要增加吗?',
            list: '%{name} 列表',
            loading: '加载中',
            not_found: '未发现',
            show: '%{name} #%{id}',
        },
        input: {
            file: {
                upload_several:
                    '将文件集合拖拽到这里, 或点击这里选择文件集合.',
                upload_single: '将文件拖拽到这里, 或点击这里选择文件.',
            },
            image: {
                upload_several:
                    '将图片文件集合拖拽到这里, 或点击这里选择图片文件集合.',
                upload_single:
                    '将图片文件拖拽到这里, 或点击这里选择图片文件.',
            },
            references: {
                all_missing: '未找到参考数据.',
                many_missing:
                    '至少有一条参考数据不再可用.',
                single_missing:
                    '关联的参考数据不再可用.',
            },
            password: {
                toggle_visible: '隐藏密码',
                toggle_hidden: '显示密码',
            },
        },
        message: {
            about: '关于',
            are_you_sure: '您确定操作?',
            bulk_delete_content:
                '您确定要删除 %{name}? |||| 您确定要删除 %{smart_count} 项?',
            bulk_delete_title:
                '删除 %{name} |||| 删除 %{smart_count}项 %{name} ',
            delete_content: '您确定要删除该条目?',
            delete_title: '删除 %{name} #%{id}',
            error:
                "客户端错误导致请求未完成.",
            invalid_form: '表单输入无效. 请检查错误提示',
            loading: '正在加载页面, 请稍候',
            no: '否',
            not_found:
                '您输入了错误的URL或者错误的链接.',
            unsaved_changes:
                "修改未保存，放弃修改吗?",
            yes: '是',
        },
        navigation: {
            clear_filters: '清除筛选',
            no_filtered_results: '使用当前筛选器找不到结果',

            no_results: '结果为空',
            no_more_results:
                '页码 %{page} 超出边界. 试试上一页.',
            page_out_of_boundaries: '页码 %{page} 超出边界',
            page_out_from_end: '已到最末页',
            page_out_from_begin: '已到最前页',
            page_range_info: '%{offsetBegin}-%{offsetEnd} / %{total}',
            page_rows_per_page: '每页行数:',
            next: '向后',
            prev: '向前',
            skip_nav: '跳到内容',
        },
        sort: {
            sort_by: '按 %{field} %{order}',
            ASC: '升序',
            DESC: '降序',
        },
        auth: {
            auth_check_error: '请登录以继续',
            user_menu: '设置',
            username: '用户名',
            password: '密码',
            sign_in: '登录',
            sign_in_error: '验证失败, 请重试',
            logout: '退出',
        },
        notification: {
            updated: '条目已更新 |||| %{smart_count} 项条目已更新',
            created: '条目已新建',
            deleted: '条目已删除 |||| %{smart_count} 项条目已删除',
            bad_item: '不正确的条目',
            item_doesnt_exist: '条目不存在',
            http_error: '与服务通信出错',
            canceled: '取消动作',
            data_provider_error: 'dataProvider错误. 请检查console的详细信息.',
            i18n_error:
                '无法加载指定语言包',
            logged_out: '会话失效, 请重连.',
        },
        validation: {
            required: '必填',
            minLength: '必须不少于 %{min} 个字符',
            maxLength: '必须不多于 %{max} 个字符',
            minValue: '必须不小于 %{min}',
            maxValue: '必须不大于 %{max}',
            number: '必须为数字',
            email: '必须是有效的邮箱',
            oneOf: '必须为: %{options}其中一项',
            regex: '必须符合指定的格式 (regexp): %{pattern}',
        },
        sideMenu: {
            home: '首页',
            trafficSales: {
                title: '流量销售',
                addUser: '账号管理',
                trafficRevenue: '权益管理',
                runningVolume: '流量管理',
                strategy: '流量策略设定',
                deploy: '流量部署',
                wxDeploy: '网心流量部署',
                wxSnManage: '网心SN管理',
                equipmentDetails: '流量设备明细',
            },
            equipmentSales: {
                title: '设备销售',
                deviceAccount: '账号管理',
                deviceRevenue: '权益管理',
                financeManage: '财务管理',
                Inventory: '库存管理',
                storeManage: '入库管理',
                outboundManage: '出库管理',
                otaUpgrade: '系统升级',
                upgradeSystem: '系统包管理',
                equipment: '设备管理',
            },
            factory: {
                title: '工厂端',
                storeProduct: '产品入库',
                outboundQueryList: '出库查询',
                outboundProduct: '产品出库',
                factoryTesting: '序列号管理',
                MACAddress: 'MAC地址管理',
            }

        },
        configurable: {
            customize: '自定义',
            configureMode: '配置此页面',
            inspector: {
                title: '界面配置器',
                content: '悬停于应用界面元素上进行配置',
                reset: '重置设置',
                hideAll: '隐藏全部',
                showAll: '显示全部'
            },
            Datagrid: {
                title: '数据表格',
                unlabeled: '未标记列 #%{column}'
            },
            SimpleForm: {
                title: '表单',
                unlabeled: '未标记输入项 #%{input}'
            },
            SimpleList: {
                title: '列表',
                primaryText: '主文本',
                secondaryText: '副文本',
                tertiaryText: '辅助文本'
            }
        }
    },
    pos: {
        search: '搜索',
        configuration: '配置',
        language: '语言',
        theme: {
            name: '主题',
            light: '明亮模式',
            dark: '黑暗模式',
        },
        dashboard: {
            daily_revenue: '今日收益',
            title: '边缘计算平台',
        },
        menu: {
            sales: '销售',
            catalog: '商品目录',
            customers: '客户',
        },
        events: {
            review: {
                title: '对 "%{product}" 发表了评论',
            },
            order: {
                title: '订购了 1 张海报 |||| 订购了 %{smart_count} 张海报',
            },
        },
    },
};

export default customChineseMessages;